define("settings/components/modal/leave-later", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object", "@ember/service", "@ember/object/computed", "@ember/utils", "@ember/runloop", "later/utils/fetch", "later/errors/fetch"], function (_exports, _component, _templateFactory, _component2, _tracking, _object, _service, _computed, _utils, _runloop, _fetch, _fetch2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _trackAccountDeletion;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@canClose}} as |modal|>
    <modal.card class="has--footer">
      <modal.card-header {{did-insert this.addEventListeners}}  @title={{t "account.profile.leave.title"}} class="u--p__b" />
      <modal.card-body>
        <p>{{t "account.profile.leave.sub_title"}}</p>
        <form id="accountDeleteFeedback" class="o--formWrapper">
          <input name="Name" type="hidden" value="{{this.ownerName}} ({{this.companyName}})">
          <input name="Email" type="hidden" value={{this.ownerEmail}}>
          <div class="o--form__radio u--m__b">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="doesn't post automatically">
              {{t "account.profile.leave.reason_automatically"}}
            </label>
          </div>
          <div class="o--form__radio u--m__b">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="confusing/difficult to use">
              {{t "account.profile.leave.reason_confusing"}}
            </label>
          </div>
          <div class="o--form__radio u--m__b">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="switching to another platform">
              {{t "account.profile.leave.reason_platform"}}
            </label>
          </div>
          <div class="o--form__radio u--m__b__lg qa--settings_leave_delete_reason_radio_button_other">
            <label class="u--text--bold u--p__l__lg">
              <input name="Reason" type="radio" value="other">
              {{t "shared_words.other"}}
            </label>
          </div>
          <div class="o--formWrapper">
            <textarea
              name="Message"
              rows="4"
              placeholder={{t "account.profile.leave.feedback"}}
              class="qa--settings_leave_delete_reason_textarea"
            ></textarea>
          </div>
        </form>
        <p>{{html-safe (t "account.profile.leave.note")}}</p>
        <p class={{if this.isHighlighted "u--text--danger"}}>
          {{t "account.profile.leave.type_destroy_part_1"}}<span translate="no">{{t "account.profile.leave.type_destroy_word"}}</span>{{t "account.profile.leave.type_destroy_part_2"}}
        </p>
        <form id="accountDeleteConfirmation" class="o--formWrapper" onsubmit="return false" {{did-insert this.onInsert}}>
          <Input class="qa--settings_leave_destroy_reason_input" @value={{this.inputValue}} />
        </form>
      </modal.card-body>
      <modal.card-footer>
        <div class="o--btnBar">
          <div
            class="o--btn o--btn--outline qa--delete_confirm u--float--right {{if this.canDestroy "" "u--mute"}}"
            id="deleteConfirmation"
            {{on "click" this.deleteConfirmation}}
          >
            {{t "account.profile.leave.confirm_delete"}}
          </div>
          {{#if this.currentAccount.hasActiveSubscription}}
            <Shared::Ui::Button
              class="u--float--right"
              @size="regular"
              @type="primary"
              @text={{t "account.profile.leave.go_back_to_free"}}
              @onClick={{@goToFree}}
            />
          {{/if}}
        </div>
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  
  */
  {
    "id": "kww08azP",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"has--footer\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"u--p__b\"],[4,[38,2],[[30,0,[\"addEventListeners\"]]],null]],[[\"@title\"],[[28,[37,1],[\"account.profile.leave.title\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,1],[\"account.profile.leave.sub_title\"],null]],[13],[1,\"\\n      \"],[10,\"form\"],[14,1,\"accountDeleteFeedback\"],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[10,\"input\"],[14,3,\"Name\"],[15,2,[29,[[30,0,[\"ownerName\"]],\" (\",[30,0,[\"companyName\"]],\")\"]]],[14,4,\"hidden\"],[12],[13],[1,\"\\n        \"],[10,\"input\"],[14,3,\"Email\"],[15,2,[30,0,[\"ownerEmail\"]]],[14,4,\"hidden\"],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"doesn't post automatically\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"account.profile.leave.reason_automatically\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"confusing/difficult to use\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"account.profile.leave.reason_confusing\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"switching to another platform\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"account.profile.leave.reason_platform\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--form__radio u--m__b__lg qa--settings_leave_delete_reason_radio_button_other\"],[12],[1,\"\\n          \"],[10,\"label\"],[14,0,\"u--text--bold u--p__l__lg\"],[12],[1,\"\\n            \"],[10,\"input\"],[14,3,\"Reason\"],[14,2,\"other\"],[14,4,\"radio\"],[12],[13],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_words.other\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n          \"],[10,\"textarea\"],[14,3,\"Message\"],[14,\"rows\",\"4\"],[15,\"placeholder\",[28,[37,1],[\"account.profile.leave.feedback\"],null]],[14,0,\"qa--settings_leave_delete_reason_textarea\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,[28,[35,3],[[28,[37,1],[\"account.profile.leave.note\"],null]],null]],[13],[1,\"\\n      \"],[10,2],[15,0,[52,[30,0,[\"isHighlighted\"]],\"u--text--danger\"]],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"account.profile.leave.type_destroy_part_1\"],null]],[10,1],[14,\"translate\",\"no\"],[12],[1,[28,[35,1],[\"account.profile.leave.type_destroy_word\"],null]],[13],[1,[28,[35,1],[\"account.profile.leave.type_destroy_part_2\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,\"form\"],[24,1,\"accountDeleteConfirmation\"],[24,0,\"o--formWrapper\"],[24,\"onsubmit\",\"return false\"],[4,[38,2],[[30,0,[\"onInsert\"]]],null],[12],[1,\"\\n        \"],[8,[39,5],[[24,0,\"qa--settings_leave_destroy_reason_input\"]],[[\"@value\"],[[30,0,[\"inputValue\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n        \"],[11,0],[16,0,[29,[\"o--btn o--btn--outline qa--delete_confirm u--float--right \",[52,[30,0,[\"canDestroy\"]],\"\",\"u--mute\"]]]],[24,1,\"deleteConfirmation\"],[4,[38,6],[\"click\",[30,0,[\"deleteConfirmation\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.profile.leave.confirm_delete\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasActiveSubscription\"]],[[[1,\"          \"],[8,[39,7],[[24,0,\"u--float--right\"]],[[\"@size\",\"@type\",\"@text\",\"@onClick\"],[\"regular\",\"primary\",[28,[37,1],[\"account.profile.leave.go_back_to_free\"],null],[30,3]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]],[1,\"\\n\"]],[\"@canClose\",\"modal\",\"@goToFree\"],false,[\"shared/modal\",\"t\",\"did-insert\",\"html-safe\",\"if\",\"input\",\"on\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/modal/leave-later.hbs",
    "isStrictMode": false
  });

  let LeaveLater = (_dec = (0, _computed.alias)('auth.currentAccount'), _dec2 = (0, _computed.readOnly)('auth.currentUserModel'), _dec3 = (0, _computed.readOnly)('currentAccount.socialProfiles.firstObject'), _dec4 = (0, _computed.readOnly)('currentUser.email'), _dec5 = (0, _computed.readOnly)('currentUser.name'), (_class = (_trackAccountDeletion = /*#__PURE__*/new WeakSet(), class LeaveLater extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _trackAccountDeletion);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);

      _initializerDefineProperty(this, "currentAccount", _descriptor6, this);

      _initializerDefineProperty(this, "currentUser", _descriptor7, this);

      _initializerDefineProperty(this, "socialProfile", _descriptor8, this);

      _initializerDefineProperty(this, "ownerEmail", _descriptor9, this);

      _initializerDefineProperty(this, "ownerName", _descriptor10, this);

      _initializerDefineProperty(this, "inFlight", _descriptor11, this);

      _initializerDefineProperty(this, "isHighlighted", _descriptor12, this);

      _initializerDefineProperty(this, "inputValue", _descriptor13, this);
    }

    get companyName() {
      if (!(0, _utils.isEmpty)(this.socialProfile)) {
        return "".concat(this.socialProfile.displayNickname, " -- ").concat(this.socialProfile.platformAbbreviation);
      }

      return null;
    }

    get canDestroy() {
      return this.inputValue === this.intl.t('account.profile.leave.type_destroy_word') && !this.inFlight;
    }

    onInsert(element) {
      element.addEventListener('submit', () => false);
    }

    deleteConfirmation() {
      if (!this.canDestroy) {
        this.isHighlighted = true;
        (0, _runloop.later)(() => {
          this.isHighlighted = false;
        }, 3000);
      } else {
        var _form$querySelector;

        const form = document.getElementById('accountDeleteFeedback');
        const reasons = form.querySelectorAll('input[name="Reason"]');
        let isChecked = false;
        let selectedReason = null;
        const comment = (_form$querySelector = form.querySelector('textarea[name="Message"]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value;

        for (const reason of reasons) {
          if (reason.checked) {
            isChecked = true;
            selectedReason = reason.value;
          }
        }

        if (isChecked) {
          _classPrivateMethodGet(this, _trackAccountDeletion, _trackAccountDeletion2).call(this, selectedReason, comment);

          this.leave();
        } else {
          this.alerts.alert(this.intl.t('alerts.account.profile.leave.select_reason'));
        }
      }
    }

    addEventListeners() {
      const deleteForm = document.getElementById('accountDeleteConfirmation');
      deleteForm.addEventListener('submit', () => false);
    }

    leave() {
      this.inFlight = true;
      document.querySelector('#deleteConfirmation').classList.add('o--btn--disabled');
      this.destroyAccountAndLogout();
    }

    async destroyAccountAndLogout() {
      try {
        await this.currentAccount.destroyRecord();
        await this._logout();
      } catch (error) {
        this.errors.handleAdapter(error);
      }
    }

    /**
     * @method _logout
     * @private
     *
     * clear local storage, invalidate session and redirect to later.com
     * this method reimplements logout functionality that is in the auth service because
     * a race condition exists when deleting an account that causes auth.logout to fail
     *
     */
    async _logout() {
      try {
        this.auth.setHasRedirectUrl(true);
        this.auth.clearLocalStorage();
        await (0, _fetch.fetch)('/users/sign_out');
      } catch (error) {
        if (error instanceof _fetch2.FetchError) {
          error.resolve.call(this, null, error.message);
        }
      } finally {
        this.auth.clearSessionAndRedirect('https://later.com/?goodbye=true');
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentAccount", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "socialProfile", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "ownerEmail", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "ownerName", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "inFlight", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isHighlighted", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "inputValue", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "deleteConfirmation", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteConfirmation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addEventListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addEventListeners"), _class.prototype)), _class));
  _exports.default = LeaveLater;

  function _trackAccountDeletion2(reason, comment) {
    const payload = {
      reason,
      comment
    };
    this.segment.track('deleted-account', payload);
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, LeaveLater);
});